import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchedulesHelperService {

  private readonly _eventId = signal<string | number | null>(null);
  private readonly _selectedEvent = signal<any>(null);
  private readonly _isDrawerOpen = signal<boolean>(false);
  private readonly _action = signal<'create' | 'edit' | null>(null);
  private readonly _type = signal<'view' | 'form' | null>(null);

  // Subject to emit when drawer closes
  private readonly _drawerClosed = new Subject<void>();

  // private readonly _isDrawerOpen = signal<boolean>(true);
  // private readonly _action = signal<'create' | 'edit' | null>('create');
  // private readonly _type = signal<'view' | 'form' | null>('form');

  readonly eventId = this._eventId.asReadonly();
  readonly selectedEvent = this._selectedEvent.asReadonly();
  readonly isDrawerOpen = this._isDrawerOpen.asReadonly();
  readonly action = this._action.asReadonly();
  readonly type = this._type.asReadonly();
  readonly date = signal<Date | null>(null);
  // When creating a schedule from the calendar, this holds the pre-selected start/end date-times
  readonly preselectedRange = signal<{ start: Date; end: Date } | null>(null);


  // Observable to subscribe to drawer close events
  readonly drawerClosed$ = this._drawerClosed.asObservable();

  openDrawer(type: 'view' | 'form', action: 'create' | 'edit' | null = null, eventId: number | string | null = null, selectedEvent: any = null, date: Date | null = null) {
    this._isDrawerOpen.set(true);
    this._type.set(type);
    this._action.set(action);
    this._eventId.set(eventId);
    this._selectedEvent.set(selectedEvent);
    this.date.set(date);
  }

  closeDrawer() {
    this._isDrawerOpen.set(false);
    this._type.set(null);
    this._action.set(null);
    this._eventId.set(null);
    this._selectedEvent.set(null);
    this.date.set(null);
    // Emit event to notify subscribers that drawer has closed
    this._drawerClosed.next();
  }

  setEventId(id: string | null) {
    this._eventId.set(id);
  }

  setSelectedEvent(event: any) {
    this._selectedEvent.set(event);
  }

  setAction(action: 'create' | 'edit' | null) {
    this._action.set(action);
  }

  setType(type: 'view' | 'form' | null) {
    this._type.set(type);
  }

  toggleDrawer() {
    this._isDrawerOpen.update(open => !open);
  }




}
